__turbopack_context__.v({
  "item": "popular-searches-list-module-scss-module__iv8H7q__item",
  "loading": "popular-searches-list-module-scss-module__iv8H7q__loading",
  "shine": "popular-searches-list-module-scss-module__iv8H7q__shine",
});
